module.exports = __webpack_public_path__ + "static/subset-UniNeueBold-Italic-9b360c41413820da9615a74547f9baf0.woff2";